import { render, staticRenderFns } from "./MypackConsultation.vue?vue&type=template&id=3b2af671&"
import script from "./MypackConsultation.vue?vue&type=script&lang=js&"
export * from "./MypackConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports